import React from "react";
import { Helmet } from "react-helmet-async";
import "./rodo.scss";

export default function Rodo() {
  return (
    <section className="rodo-page">
      <>
          <Helmet>
              <title>Pro Moto - polityka prywatności</title>
              <meta
              name="description"
              content="PRO MOTO Oferujemy kompleksowy serwis motocykli, quadów i skuterów — od podstawowej obsługi po zaawansowane naprawy"
              />
              <link rel="canonical" href="https://promotoserwis.pl/polityka-prywatności" />
          </Helmet>
      </>
      <div className="rodo-container">
        <h1>Polityka Prywatności</h1>

        <h2>1. Pliki cookies</h2>
        <p>
          Strona promotoserwis.pl korzysta z plików cookies w celu:
        </p>

        <ul>
          <li>zapewnienia prawidłowego działania serwisu,</li>
          <li>analizy ruchu na stronie,</li>
          <li>personalizacji treści i reklam.</li>
        </ul>

        <p>
          Użytkownik może zarządzać ustawieniami cookies za pomocą swojej przeglądarki internetowej.
        </p>

        <p>
          Niniejsza strona internetowa, tak jak większość stron tego typu, wykorzystuje pliki „cookies”.
          Pliki „cookies” są to niewielkie pliki, najczęściej tekstowe, zapisywane na urządzeniu,
          za pośrednictwem którego Państwo odwiedzają naszą stronę. W plikach „cookies” zapisane są
          ustawienia internetowe, które pozwalają m.in. „rozpoznać” Państwa przy ponownej wizycie na
          naszej stronie. Stosowanie plików „cookies” ma na celu zapewnienie prawidłowej funkcjonalności
          naszej strony i dostosowania jej do Państwa preferencji i potrzeb, np. poprzez prezentowanie
          Państwu reklam uwzględniających Państwa zainteresowania lub zaniechanie ponownego prezentowania
          tej samej reklamy.
        </p>

        <p>
          Czas przechowywania danych, które w niektórych przypadkach mogą stanowić dane osobowe,
          w plikach cookies, zależy od ich rodzaju oraz ustawień przeglądarki na urządzeniu końcowym.
        </p>

        <h2>2. Ograniczenie odpowiedzialności</h2>
        <p>
          PRO MOTO dołożyło starań w przygotowaniu niniejszej strony internetowej, nie możemy jednak
          zagwarantować, że zawarte na niej informacje są wolne od jakichkolwiek błędów i omyłek.
          Zaznaczamy, że nie ponosimy odpowiedzialności za jakiekolwiek szkody powstałe w skutek wykorzystania
          informacji zawartych na niniejszej stronie internetowej lub uzyskanych za jej pośrednictwem,
          z wyjątkiem sytuacji, gdy powstałe szkody są rezultatem działań bezpośrednio przez nas zawinionych.
        </p>

        <p>
          Jednocześnie polecamy Państwu podejmowanie koniecznych środków ostrożności podczas korzystania
          z niniejszej strony, w tym zabezpieczenie się przed wirusami i trojanami komputerowymi.
          Nie ponosimy odpowiedzialności za uszkodzenia sprzętu, jak też wirusy oraz trojany, które
          mogą zaatakować Państwa sprzęt w związku z dostępem do niniejszej strony internetowej,
          o ile nie będzie to rezultatem działań bezpośrednio przez nas zawinionych.
        </p>

        <p>
          Niniejsza strona internetowa może zawierać odnośniki do innych stron internetowych,
          administrowanych przez osoby trzecie, na których zawartość nie mamy wpływu i za treść
          których nie ponosimy odpowiedzialności.
        </p>

        <h2>3. Linki do zewnętrznych stron internetowych</h2>
        <p>
          W przypadku gdyby niniejsza strona internetowa zawierała odesłania (linki) do stron internetowych
          podmiotów zewnętrznych, informujemy, że nie ponosimy odpowiedzialności za funkcjonowanie,
          czy politykę prywatności takich zewnętrznych stron internetowych. Podmioty te mogą również
          wykorzystywać pliki cookies. Dlatego zwracamy uwagę na konieczność zapoznania się z politykami
          prywatności zawartymi na innych stronach internetowych we własnym zakresie.
        </p>
      </div>
    </section>
  );
}
